var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFullscreenExit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "EF68E565-4F3E-4958-9E50-274870AAA269")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-777.000000, -720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38-Copy",
    transform: "translate(299.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(172.100000, 66.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-Outlined-/-Navigation-/-fullscreen_exit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Navigation-/-fullscreen_exit"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 45 0 45 45 0 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375,30 L15,30 L15,35.625 L18.75,35.625 L18.75,26.25 L9.375,26.25 L9.375,30 Z M15,15 L9.375,15 L9.375,18.75 L18.75,18.75 L18.75,9.375 L15,9.375 L15,15 Z M26.25,35.625 L30,35.625 L30,30 L35.625,30 L35.625,26.25 L26.25,26.25 L26.25,35.625 Z M30,15 L30,9.375 L26.25,9.375 L26.25,18.75 L35.625,18.75 L35.625,15 L30,15 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFullscreenExit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fullscreen_exit.8a0d936f.svg";
export { ForwardRef as ReactComponent };